/**
 * Reducer for wrong answer tutorials. Triggers a wrong answer tutorial if
 * the user gets a question wrong and has not already completed the tutorial
 */

import { fromJS } from 'immutable';
import log from 'loglevel';

import { QUESTION_ACTIVITY_FINISHED } from 'phoenix2/state/question-activity/actions';
import { EVALUATIONS } from 'phoenix2/state/question-activity/question-activity';
import { SET_TUTORIALS_COMPLETED, RESET_TUTORIALS } from '../actions';
import { SET_WRONG_ANSWER_INCORRECT_COMPLETED } from '../tutorial-actions/wrong-answer';

export const WRONG_ANSWER_TUTORIAL_KEY = 'wrongAnswerTutorial';

const INITIAL_STATE = fromJS({
    completed: false,

    // Disabled by default until a user gets a question wrong
    active: false,
    state: null,
});

export function wrongAnswerTutorialReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;

        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(WRONG_ANSWER_TUTORIAL_KEY) !== -1) {
                return fromJS({
                    completed: true,
                    active: false,
                    state: null,
                });
            }
            break;

        case QUESTION_ACTIVITY_FINISHED:
            return triggerWrongAnswerTutorial(state, action);

        // Because this is a two part tutorial, we need an action to be able to
        // dismiss the first part.
        case SET_WRONG_ANSWER_INCORRECT_COMPLETED:
            state = state.setIn(['state', 'incorrectTutorialCompleted'], true);
    }

    return state;
}

/**
 * Given a QUESTION_ACTIVITY_FINISHED action, trigger a wrong answer tutorial if
 * the criteria are met: the tutorial should not already have been completed,
 * and the user must have just made an attempt at a task which they got wrong.
 * The task item id is recorded in the tutorial state so that the tutorial can
 * point to it
 * @param state the redux state
 * @param action a DEEP_UPDATE_TASK_ITEM_STATE action
 * @returns {*}
 */
function triggerWrongAnswerTutorial(state, action) {
    // The wrong answer tutorial is only ever shown once so never triggered
    // if already completed
    const wrongAnswerTutorialComplete = state.get('completed');

    if (!wrongAnswerTutorialComplete && action.evaluation === EVALUATIONS.wrong) {
        log.debug('Wrong answer tutorial triggered', action);

        // When the tutorial is first triggered, we want the store to show
        // what task item it is associated with and also that the first part of
        // it, the incorrect tutorial, has not yet been completed.
        return fromJS({
            completed: false,
            active: true,
            state: {
                taskItemId: action.questionActivity.get('taskItemId'),
                incorrectTutorialCompleted: false,
            },
        });
    }

    return state;
}
